// extracted by mini-css-extract-plugin
export default {"wrapper":"layout-module--wrapper--2e9ef","main":"layout-module--main--9f45c"};